import * as DTO from '@rw1/auto-generated-clients/generated/company-data-v2/dto.generated'
import * as Models from '@rw1/models'
import { injectable } from 'inversify'
import { ICompanyDataMapper } from './ICompanyDataMapper'

@injectable()
export class CompanyDataMapper implements ICompanyDataMapper {
    toCompanyModel(dto: DTO.Company): Models.Company {
        return {
            companyId: dto.companyId,
            companyName: dto.companyName,
            defaultUserGroupId: dto.defaultUserGroupId,
            friendlyName: dto.friendlyName,
            isPartnerCompany: dto.isPartnerCompany,
            companyIconURL: dto.companyIconURL,
            headerIconURL: dto.headerIconURL,
            isVisibleToExternalUsers: dto.isVisibleToExternalUsers,
            libraryCardURL: dto.libraryCardURL,
            shirtLogoURL: dto.shirtLogoURL,
            showroomRoomId: dto.showroomRoomId,
            sSODomain: dto.sSODomain
        }
    }
}